import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppSettings } from '../../common/app.settings';
import { ErrorHandler } from '../../common/errorHandler';
import { AuthenticationService } from '../../services/authentication.service';
import { VoteLocationService } from '../../services/vote.location.service';
import { VoteLocation } from '../../models/vote.location.model';
import { ResultCode } from '../../enums/resultcode.enum';
import { Party } from '../../enums/party.enum';

@Component({
    selector: 'votelocation-list',
    templateUrl: './votelocation-list.component.html',
    styleUrls: ['./votelocation-list.component.css'],
    providers: [VoteLocationService, ErrorHandler]
})
export class VoteLocationListComponent implements OnInit {
    voteLocations: Array<VoteLocation>;
    isDataAvailable = false;
    keys: any[];
    parties = Party;
    party: Party;

    constructor(
        private router: Router,
        private errorHandler: ErrorHandler,
        private voteLocationService: VoteLocationService) {
        this.voteLocations = new Array<VoteLocation>();
        this.keys = Object.keys(this.parties).filter(Number);
        this.party = Party.unbekannt; //Default the value
    }

    ngOnInit() {
        this.getAll();
    }

    getAll(): void {
        this.voteLocationService.getVoteLocations()
                    .then(voteLocations => {
                        this.voteLocations = voteLocations;
                        this.isDataAvailable = true;
                    })
                    .catch(error => {
                        this.errorHandler.do(error);
                        this.isDataAvailable = true;
                    });
        }

    edit(voteLocationId: string): void {
        this.router.navigate(['voteLocation/detail', voteLocationId]);
    }

    add(): void {
        this.router.navigate(['voteLocation/detail', 0]);
    }

    delete(voteLocationId: string): void {
        this.isDataAvailable = false;
        this.voteLocationService.delete(voteLocationId)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.getAll();
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    getParty(party: string): string {
        let returnValue = '';
        if(party !== undefined && this.parties != undefined) {
            returnValue = this.parties[party];
        }

        return returnValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/votelocation-list/votelocation-list.component.ts